import { DataGrid } from "devextreme-react";
import { Editing, Item, Toolbar } from "devextreme-react/data-grid";
import { EditingStartEvent, NewRowInfo } from "devextreme/ui/data_grid";
import * as React from "react";
import { useCallback } from "react";

interface IProps<TModel extends { id?: number }> {
    gridRef?: React.RefObject<DataGrid<TModel, number>>
    list: any[];
    valueChanged: (list: any[]) => void;
    children?: React.ReactChild | React.ReactChild[]
    onEditing?: (e: EditingStartEvent<TModel, number>) => void;
}

const DataGridArrayList = <TModel extends { id?: number }>({ gridRef, list, valueChanged, children, onEditing }: IProps<TModel>) => {

    const [newId, setNewId] = React.useState(0);

//    const test = useRef<DataGrid<TModel, number>>(null);
    const createNewId = useCallback(() => {
        setNewId(p => --p);
        return newId
    }, [newId])

    const triggerChanged = useCallback(() => {
        valueChanged(list);
    }, [valueChanged, list])

    const newRowData = useCallback((e: NewRowInfo<TModel>) => e.data.id = createNewId(), [createNewId])

    return <DataGrid<TModel, number>
        ref={gridRef}
        keyExpr="id"
        hoverStateEnabled
        showRowLines
        dataSource={list}
        onSaved={triggerChanged}
        onInitNewRow={newRowData}
        onEditingStart={onEditing}
    >
        <Editing allowAdding allowDeleting allowUpdating mode="batch" useIcons />
        <Toolbar>
            <Item name="addRowButton" location="left" />
        </Toolbar>
        {children}

    </DataGrid>
}
export default DataGridArrayList;